export const inactiveColor = 'rgb(185, 193, 200)';
export const activeColor = '#49303A';
export const activeAccentColor = 'var(--dui-primary)';
